export const rangeOptions = [
  '3 Hours',
  '6 Hours',
  '12 Hours',
  '1 Day',
  '2 Days',
  '4 Days',
  '7 Days',
  '14 Days',
  '1 Month',
  '2 Months',
  '3 Months',
  '6 Months',
  '1 Year'
]
